// extracted by mini-css-extract-plugin
export default {"root":"ViewerSaveToCloudButton__root--1c3nP","icon":"ViewerSaveToCloudButton__icon--3PqrT","text":"ViewerSaveToCloudButton__text--2wDdA"};